module.exports = __webpack_public_path__ + "static/media/mail_icon_open@3x.b0ef5a39.png";